import React, { Component } from "react"
import { withRouter } from "react-router-dom";

import Qrcode from "qrcode.react";
import PropTypes from 'prop-types';

//Verification code package
import { connect } from "react-redux";
import AuthCode from "react-auth-code-input"

import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Row,
} from "reactstrap"

import { loginApiError, verify2fCode, } from "../../store/actions";

class TwostepReadQr extends Component {
  constructor(props) {
    super(props)
    this.state = {
      sixDigit: ""
    }
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
  }

  handleValidSubmit(event, values) {
    const verify = {
      verificationCode: this.state.sixDigit,
      QrString: localStorage.getItem("qrString"),
    };
    this.props.verify2fCode(verify, this.props.history);
  }

  handleOnChange = (res) => {
    this.setState({ sixDigit: res });
  };


  render() {
    return (
      <React.Fragment>
        <div className="account-pages my-5 pt-sm-5">

          <title>Finagotech |  Verify Qr</title>

          <Container>

            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card>
                  <CardBody>
                    <div className="p-1">
                      <div className="text-center">
                        <div className="avatar-md mx-auto">
                          <div className="avatar-title rounded-circle bg-light">
                            <i className="bx bxs-key h1 mb-0 text-primary"></i>
                          </div>
                        </div>
                        <div className="p-2 mt-4">
                          <h4>Read Qrcode with Authenticator</h4>
                          <Qrcode value={`otpauth://totp/WeChip:${localStorage.getItem("username")}?secret=${localStorage.getItem("qrString")}&period=30&digits=6&algorithm=SHA1&issuer=WeChip`} />
                          <p className="mb-5">
                            <br />
                            <br />
                            <span className="font-weight-semibold">
                              Please enter the 6 digit code sent to{" "}
                            </span>
                          </p>

                          <Form>
                            <Row>
                              <Col xs={12}>
                                <FormGroup className="verification">
                                  <label
                                    htmlFor="digit1-input"
                                    className="sr-only"
                                  >
                                    Dight 1
                                  </label>
                                  <AuthCode
                                    characters={6}
                                    onChange={this.handleOnChange}
                                    name="sixDigit"
                                    allowedCharacters="numeric"
                                    value={this.state.sixDigit}
                                    inputClassName="authInput"
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                          </Form>

                          <div className="mt-4">
                            <button
                              className="btn btn-primary btn-block"
                              onClick={this.handleValidSubmit}
                            >
                              Confirm
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
                <div className="mt-5 text-center">

                  <p>
                    © {new Date().getFullYear()}  Finagotech
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

TwostepReadQr.propTypes = {
  apiError: PropTypes.any,
  error: PropTypes.any,
  history: PropTypes.object,
  verify2fCode: PropTypes.func
};



const mapStateToProps = state => {
  const { error } = state;
  return { error };
};

export default withRouter(
  connect(mapStateToProps, { verify2fCode, loginApiError })(TwostepReadQr)
);

